import * as React from 'react';
import { NextPage } from 'next';
import { Dispatch } from 'redux';
import { useRouter } from 'next/router';
import Head from 'next/head';

import { ApiKeyContext } from 'contexts/ApiKeyContext';
import { ProductCollection } from 'components/PrivateMarketplace/ProductCollection/ProductCollection';
import { PrivateMarketplaceLayout } from 'components/PrivateMarketplaceLayout/PrivateMarketplaceLayout';
import { wrapper } from 'ducks';
import { fetchSettingsServerSide } from 'ducks/server';
import { fetchProductSummariesServerSide } from 'ducks/server';
import { fetchCustomPagesServerSide } from 'ducks/server';
import { fetchConfigForHostname } from 'lib/util/fetchConfigForHostname';
import { getI18nServerSideProps } from 'i18n';
import { withSSR } from 'withSSR';
import { absoluteUrl } from 'lib/util/absoluetUrl';

interface Props {
  apiKey: string;
  host: string;
}

const Category: NextPage<Props> = ({ apiKey, host }) => {
  const router = useRouter();

  return (
    <ApiKeyContext.Provider
      value={{
        apiKey,
        useApiKeyInPaths: false,
      }}
    >
      <Head>
        <meta property="og:url" content={`${host}${router.asPath.split('?')[0]}`} />
      </Head>
      <PrivateMarketplaceLayout>
        <ProductCollection host={host} />
      </PrivateMarketplaceLayout>
    </ApiKeyContext.Provider>
  );
};

export const getServerSideProps = wrapper.getServerSideProps(async ({ req, store }) => {
  const hostname = req.headers?.host?.split(':')[0] || '';
  const { apiKey, lang } = await fetchConfigForHostname(hostname);

  const dispatch: Dispatch<any> = store.dispatch;
  await Promise.all([
    dispatch(fetchSettingsServerSide(apiKey, '', lang, `https://${hostname}`)),
    dispatch(fetchProductSummariesServerSide(apiKey, lang)),
    dispatch(fetchCustomPagesServerSide(apiKey, lang)),
  ]);

  const i18nProps = await getI18nServerSideProps(lang);

  (req as any).locale = lang;

  return {
    props: {
      apiKey,
      host: absoluteUrl(req),
      ...i18nProps,
    },
  };
});

export default withSSR()(Category);
